/// <amd-module name="SuiteCommerce.PagePrinter.Shopping"/>
define("SuiteCommerce.PagePrinter.Shopping", ["require", "exports", "SuiteCommerce.PagePrinter.Common.Configuration", "SuiteCommerce.PagePrinter.PDP", "SuiteCommerce.PagePrinter.ItemDetailsLayout", "SuiteCommerce.PagePrinter.ExtQRCode", "SuiteCommerce.PagePrinter.Common.InstrumentationHelper"], function (require, exports, Configuration_1, PDP, ItemDetails, QRCode_1, InstrumentationHelper_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            Configuration_1.Configuration.environment = container.getComponent('Environment');
            InstrumentationHelper_1.InstrumentationHelper.initializeInstrumentation(container.getComponent('Environment'));
            QRCode_1.QRCode.install();
            PDP.mountToApp(container);
            ItemDetails.mountToApp(container);
        },
    };
});
